/** サイトのドメイン(プロトコル付き) */
let domain = window.location.protocol + '//' + window.location.host
/** URLのパラメータオブジェクト */
let urlParamObject = {};
/** 選択済みカテゴリー */
let selectedCategory = null;
/** 選択済みサブカテゴリー */
let selectedSubCategory = null;
/** 選択済み絞り込み条件 */
let selectedFilterItems = {};
/** 選択済みコラボ／タイトル */
let selectedCollaboration = null;
/** 選択済みブランド */
let selectedBrands = [];
/** 選択済みカラー */
let selectedColors = [];
/** 選択済み販売ステータス */
let selectedOnSale = false;
/** 選択済みソート順 */
let selectedSort = '';
/** キーワード(search画面でのみ活用) */
let selectedKeyword = '';
/** airReviews（レビューアプリ）のソースパス */
let airReviewsSrc = '';

/**
 * URLのパラメータをコード上で利用しやすいように、オブジェクトに変換する
 * URL例：
 * https://store.grapht.tokyo/collections/mouse?category=mouse&sub_category=mouse-itself&brands[]=grapht&brands[]=razer&collaboration=ストリートファイター&filter_items[接続方法][]=有線&filter_items[接続方法][]=ワイヤレス&filter_items[ライティング][]=あり&filter_items[重さ][]=67&filter_items[重さ][]=102&colors[]=レッド
 * この関数でパラメータをオブジェクト化すると以下のようになる
 * {
 *  category:"インテリア"
 *  sub_category:"オブジェ・置物"
 *  brands:['GRAPHT', 'RAZER']
 *  collaboration:"ストリートファイター"
 *  colors:['レッド']
 *  filter_items: {
 *   ライティング:['あり'],
 *   接続方法:['有線', 'ワイヤレス']
 *  }
 * }
 * @returns {{}}
 */
const convertUrlQueriesToObject = () => {
  let queryAll = window.location.search.slice(1);
  urlParamObject['filter_items'] = {}
  decodeURI(queryAll).split('&').forEach((queryUnit) => {
    let paramKeyValue = queryUnit.split('=');
    // カテゴリ
    if (/filter\.p\.m\.category\.name/.test(paramKeyValue[0])) {
      urlParamObject['category'] = paramKeyValue[1];
    }
    // サブカテゴリ
    else if (/filter\.p\.m\.sub_category\.name/.test(paramKeyValue[0])) {
      urlParamObject['sub_category'] = paramKeyValue[1];
    }
    // 絞り込み条件：接続方法
    else if (/filter\.p\.m\.filter_item\.access_method/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('接続方法')) {
        urlParamObject['filter_items']['接続方法'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['接続方法'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：ボタン数
    else if (/filter\.p\.m\.filter_item\.total_number_of_buttons/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('ボタン数')) {
        urlParamObject['filter_items']['ボタン数'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['ボタン数'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：重さ
    else if (/filter\.p\.m\.filter_item\.product_weight_msy/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('重さ')) {
        urlParamObject['filter_items']['重さ'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['重さ'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：ライティング
    else if (/filter\.p\.m\.filter_item\.illumination_function/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('ライティング')) {
        urlParamObject['filter_items']['ライティング'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['ライティング'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：形状
    else if (/filter\.p\.m\.filter_item\.shape/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('形状')) {
        urlParamObject['filter_items']['形状'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['形状'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：材質
    else if (/filter\.p\.m\.filter_item\.material/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('材質')) {
        urlParamObject['filter_items']['材質'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['材質'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：サイズ
    else if (/filter\.p\.m\.filter_item\.size/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('サイズ')) {
        urlParamObject['filter_items']['サイズ'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['サイズ'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：キースイッチ種類
    else if (/filter\.p\.m\.filter_item\.keyswitch_type/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('キースイッチ種類')) {
        urlParamObject['filter_items']['キースイッチ種類'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['キースイッチ種類'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：配列
    else if (/filter\.p\.m\.filter_item\.keyboard_layout/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('配列')) {
        urlParamObject['filter_items']['配列'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['配列'] = [paramKeyValue[1]];
      }
    }
    // 絞り込み条件：種類
    else if (/filter\.p\.m\.filter_item\.kind/.test(paramKeyValue[0])) {
      if (urlParamObject['filter_items'].hasOwnProperty('種類')) {
        urlParamObject['filter_items']['種類'].push(paramKeyValue[1]);
      } else {
        urlParamObject['filter_items']['種類'] = [paramKeyValue[1]];
      }
    }
    // コラボレーション
    else if (/filter\.p\.m\.collaboration\.name/.test(paramKeyValue[0])) {
      urlParamObject['collaboration'] = paramKeyValue[1];
    }
    // ブランド
    else if (/filter\.p\.m\.brand\.name/.test(paramKeyValue[0])) {
      if (!urlParamObject['brands']) urlParamObject['brands'] = [];
      urlParamObject['brands'].push(paramKeyValue[1]);
    }
    // カラー
    else if (/filter\.v\.option\.色/.test(paramKeyValue[0])) {
      if (!urlParamObject['colors']) urlParamObject['colors'] = [];
      urlParamObject['colors'].push(paramKeyValue[1]);
    }
    // 販売中
    else if (/filter.v.availability/.test(paramKeyValue[0])) {
      urlParamObject['availability'] = (paramKeyValue[1] === '1');
    }
    // ソート順
    else if (/sort_by/.test(paramKeyValue[0])) {
      urlParamObject['sort_by'] = paramKeyValue[1];
    }
    // キーワード
    else if (/q/.test(paramKeyValue[0])) {
      let keyword = paramKeyValue[1];
      if (keyword.includes('"')) {
        urlParamObject['q'] = keyword.replaceAll('"', '');
      } else {
        urlParamObject['q'] = keyword;
      }
    }
  });
}

/**
 * 選択中の条件からURLを生成する
 *
 * @returns {string}
 */
const convertObjectToUrl = () => {
  let path = selectedKeyword ? '/search?' : '/collections/all?';
  if (selectedKeyword) {
    let newKeyword = selectedKeyword;
    if (!newKeyword.match(/^[A-Za-z0-9!-/:-@¥[-`{-~]*$/)) {
      newKeyword = '"' + newKeyword + '"';
    }
    path += `${firstParamOrNot(path)}q=${newKeyword}`
  }
  if (selectedCategory && selectedCategory['handle'] !== '') {
    path += `${firstParamOrNot(path)}filter.p.m.category.name=${selectedCategory['name']}`
  }
  if (selectedSubCategory && selectedSubCategory['handle'] !== '') {
    path += `${firstParamOrNot(path)}filter.p.m.sub_category.name=${selectedSubCategory['name']}`
  }
  if (!isEmptyObject(selectedFilterItems)) {
    for (const key in selectedFilterItems) {
      if (key === 'access_method') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.access_method=${item}`;
        });
      }
      if (key === 'total_number_of_buttons') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.total_number_of_buttons=${item}`;
        });
      }
      if (key === 'product_weight_msy') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.product_weight_msy=${item}`;
        });
      }
      if (key === 'illumination_function') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.illumination_function=${item}`;
        });
      }
      if (key === 'shape') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.shape=${item}`;
        });
      }
      if (key === 'material') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.material=${item}`;
        });
      }
      if (key === 'size') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.size=${item}`;
        });
      }
      if (key === 'keyswitch_type') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.keyswitch_type=${item}`;
        });
      }
      if (key === 'keyboard_layout') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.keyboard_layout=${item}`;
        });
      }
      if (key === 'kind') {
        selectedFilterItems[key]['items'].forEach((item) => {
          path += `${firstParamOrNot(path)}filter.p.m.filter_item.kind=${item}`;
        });
      }
    }
  }
  if (selectedCollaboration && selectedCollaboration['handle'] !== '') {
    path += `${firstParamOrNot(path)}filter.p.m.collaboration.name=${selectedCollaboration['name']}`
  }
  if (selectedBrands.length > 0) {
    selectedBrands.forEach((brand) => {
      path += `${firstParamOrNot(path)}filter.p.m.brand.name=${brand['name']}`
    });
  }
  if (selectedColors.length > 0) {
    selectedColors.forEach((color) => {
      path += `${firstParamOrNot(path)}filter.v.option.色=${color['name']}`
    });
  }
  if (selectedOnSale) {
    path += `${firstParamOrNot(path)}filter.v.availability=1`
  }
  if (selectedSort) {
    path += `${firstParamOrNot(path)}sort_by=${selectedSort}`
  }
  path = (path.slice(-1) === '?') ? path.slice(0, -1) : path;
  return domain + path;
}

/**
 * 最初のパラメータであれば、空文字をそうでなければ'&'を返す
 *
 * @param path
 * @returns {string}
 */
const firstParamOrNot = (path) => {
  return path.slice(-1) === '?' ? '' : '&';
}

/**
 * URLのパスやパラメータから選択中のカテゴリを設定する
 * パスやパラメータでサブカテゴリが指定されていた場合、そのサブカテゴリが属するカテゴリの場合もチェックして設定する
 *
 * パラメータの優先順位：
 * 1. コレクション（パス）のサブカテゴリ
 * 2. コレクション（パス）のカテゴリ
 * 3. クエリのサブカテゴリ
 * 4. クエリのカテゴリ
 *
 * @returns {*|boolean}
 */
const setCategoryFromUrlParamObject = () => {
  // コレクションがサブカテゴリの場合、そのサブカテゴリが属しているカテゴリかどうか
  const step1 = search_condition_categories.some((category) => {
    if (!isEmptyObject(search_current_collection) && search_current_collection['type'] === 'sub_category') {
      const target = category['sub_categories'].filter(sub => sub['name'] === search_current_collection['name']);
      if (target.length > 0) {
        selectedCategory = category;
        return true;
      }
    }
  });
  if (step1) return true;
  // コレクションのカテゴリに一致しているかどうか
  const step2 =  search_condition_categories.some((category) => {
    if (!isEmptyObject(search_current_collection) && category['name'] === search_current_collection['name'] && search_current_collection['handle'] !== 'all') {
      selectedCategory = category;
      return true;
    }
  });
  if (step2) return true;
  // パラメータのサブカテゴリが属しているカテゴリかどうか
  const step3 = search_condition_categories.some((category) => {
    if (urlParamObject.hasOwnProperty('sub_category')) {
      const target = category['sub_categories'].filter(sub => sub['name'] === urlParamObject['sub_category']);
      if (target.length > 0) {
        selectedCategory = category;
        return true;
      }
    }
  });
  if (step3) return true;
  // パラメータのカテゴリに一致しているかどうか
  return search_condition_categories.some((category) => {
    if (urlParamObject.hasOwnProperty('category') && urlParamObject['category']) {
      if (category['name'] === urlParamObject['category']) {
        selectedCategory = category;
        return true;
      }
    }
  });
}

/**
 * URLのパスやパラメータから選択中のサブカテゴリを設定する
 *
 * パラメータの優先順位：
 * 1. コレクション（パス）のサブカテゴリ
 * 2. クエリのサブカテゴリ
 * 3. コレクション（パス）のカテゴリ（サブカテゴリはすべてが指定される）
 * 4. クエリのカテゴリ（サブカテゴリはすべてが指定される）
 *
 *
 * @returns {*|boolean}
 */
const setSubCategoryFromUrlParamObject = () => {
  if (selectedCategory && selectedCategory['sub_categories'].length > 0) {
    // コレクションのサブカテゴリに一致しているかどうか
    const step1 = selectedCategory['sub_categories'].some((subCategory) => {
      if (!isEmptyObject(search_current_collection) && search_current_collection['type'] === 'sub_category') {
        if (subCategory['name'] === search_current_collection['name']) {
          selectedSubCategory = subCategory;
          return true;
        }
      }
    });
    if (step1) return true;
    // パラメータのサブカテゴリに一致しているかどうか
    const step2 = selectedCategory['sub_categories'].some((subCategory) => {
      if (urlParamObject.hasOwnProperty('sub_category') && urlParamObject['sub_category']) {
        if (subCategory['name'] === urlParamObject['sub_category']) {
          selectedSubCategory = subCategory;
          return true;
        }
      }
    });
    if (step2) return true;
    // コレクション種別がカテゴリの場合
    const step3 = selectedCategory['sub_categories'].some((subCategory) => {
      if (!isEmptyObject(search_current_collection) && search_current_collection['type'] === 'category' && /すべて/.test(subCategory['name'])) {
        selectedSubCategory = subCategory;
        return true;
      }
    });
    if (step3) return true;
    // パラメータのカテゴリが指定されているかどうか
    return selectedCategory['sub_categories'].some((subCategory) => {
      if (urlParamObject.hasOwnProperty('category') && urlParamObject['category']) {
        if (/すべて/.test(subCategory['name'])) {
          selectedSubCategory = subCategory;
          return true;
        }
      }
    });
  }
  return false;
}

/**
 * URLのパラメータから選択中の絞り込み条件を設定する
 */
const setFilterItemsFromUrlParamObject = () => {
  if (selectedSubCategory && selectedSubCategory['filter_items'].length > 0) {
    selectedSubCategory['filter_items'].forEach((filterItem) => {
      // 絞り込み条件がチェックボックスの場合
      if (filterItem['type'] === 'checkbox' && filterItem['items'].length > 0) {
        filterItem['items'].forEach((item) => {
          // パラメータの絞り込み条件に一致しているかどうか
          if (urlParamObject['filter_items'].hasOwnProperty(filterItem['label'])) {
            for (const queryItem of urlParamObject['filter_items'][filterItem['label']]) {
              if (queryItem === item['name']) {
                if (!selectedFilterItems.hasOwnProperty(filterItem['key'])) {
                  selectedFilterItems[filterItem['key']] = { type: 'checkbox', items: [item['name']] };
                } else {
                  selectedFilterItems[filterItem['key']]['items'].push(item['name']);
                }
                break;
              }
            }
          }
        });
      }
    });
  }
}

/**
 * URLのパスやパラメータから選択中のコラボレーションを設定する
 *
 * 1. コレクション（パス）のコラボレーション
 * 2. クエリのコラボレーション
 *
 * @returns {*|boolean}
 */
const setCollaborationFromUrlParamObject = () => {
  // コレクションのコラボレーションに一致しているかどうか
  const step1 = search_condition_collaborations.some((collaboration) => {
    if (!isEmptyObject(search_current_collection) && search_current_collection['type'] === 'collaboration') {
      if (search_current_collection['name'].toLowerCase() === collaboration['name'].toLowerCase()) {
        selectedCollaboration = collaboration;
        return true;
      }
    }
  });
  if (step1) return true;
  // パラメータのコラボレーションに一致しているかどうか
  const step2 = search_condition_collaborations.some((collaboration) => {
    if (urlParamObject.hasOwnProperty('collaboration') && urlParamObject['collaboration']) {
      if (collaboration['name'].toLowerCase() === urlParamObject['collaboration'].toLowerCase()) {
        selectedCollaboration = collaboration;
        return true;
      }
    }
  });
  if (step2) return true;
  // コレクション種別がコラボレーション以外の場合
  return search_condition_collaborations.some((collaboration) => {
    if (!isEmptyObject(search_current_collection) && search_current_collection['type'] !== 'collaboration' && /すべて/.test(collaboration['name'])) {
      selectedCollaboration = collaboration;
      return true;
    }
  });
}

/**
 * URLのパスやパラメータから選択中のブランドを設定する
 *
 * 1. コレクション（パス）のブランド
 * 2. クエリのブランド
 *
 * @returns {*|boolean}
 */
const setBrandsFromUrlParamObject = () => {
  // コレクションのブランドに一致しているかどうか
  const step = search_condition_brands.some((brand) => {
    if (!isEmptyObject(search_current_collection) && search_current_collection['name'].toLowerCase() === brand['name'].toLowerCase()) {
      selectedBrands.push(brand);
      return true;
    }
  });
  if (step) return true;
  // パラメータのブランドに一致しているかどうか
  search_condition_brands.forEach((brand) => {
    if (urlParamObject.hasOwnProperty('brands') && urlParamObject['brands']) {
      for (const queryBrand of urlParamObject['brands']) {
        if (brand['name'].toLowerCase() === queryBrand.toLowerCase()) {
          selectedBrands.push(brand);
          break;
        }
      }
    }
  });
  return (selectedBrands.length > 0);
}

/**
 * URLのパスやパラメータから選択中のカラーを設定する
 */
const setColorsFromUrlParamObject = () => {
  search_condition_colors.forEach((color) => {
    // パラメータのカラーに一致しているかどうか
    if (urlParamObject.hasOwnProperty('colors') && urlParamObject['colors']) {
      for (const queryColor of urlParamObject['colors']) {
        if (color['name'] === queryColor) {
          selectedColors.push(color);
          break;
        }
      }
    }
  });
}

/**
 * URLのパスやパラメータで販売中が指定されているかチェックする
 */
const setOnSaleFromUrlParamObject = () => {
  if (urlParamObject.hasOwnProperty('availability') && urlParamObject['availability']) selectedOnSale = true;
}

/**
 * 選択されているソート順を設定する
 */
const setSort = () => {
  selectedSort = $("#sort-by").data('sortValue');
}

/**
 * URLのパラメータでキーワードが指定されているかチェックする
 */
const setKeyword = () => {
  selectedKeyword = urlParamObject['q'];
  $("#suggest-search-keyword").data('oldValue', selectedKeyword);
  $("#suggest-search-keyword").val(selectedKeyword);
}

/**
 * 検索条件：カテゴリーのDOMを設定する
 */
const setElementCategory = () => {
  $("#categories").empty();
  search_condition_categories.forEach((category) => {
    const selected = selectedCategory && selectedCategory['name'] === category['name'] ? 'selected' : '';
    $("#categories").append(`<option value="${category['name']}" ${selected}>${category['name']}</option>`);
  });
}

/**
 * 検索条件：サブカテゴリーのDOMを設定する
 */
const setElementSubCategory = () => {
  $("#sub_categories").empty();
  if (selectedSubCategory) {
    $(".matching-item.sub-categories").css('display', 'flex');
    if (window.innerWidth >= 960) $(".btnWrap-search-between.with-sub-categories").show();
    selectedCategory['sub_categories'].forEach((sub, index) => {
      const checked = selectedSubCategory['name'] === sub['name'] ? 'checked' : '';
      $("#sub_categories").append(`
        <span>
          <input type="radio" name="r01" id="r01-${index}" value="${sub['name']}" onChange="changeSubCategory(this)" ${checked}>
          <label for="r01-${index}">${sub['name']}</label>
        </span>
      `);
    });
  } else {
    $(".matching-item.sub-categories").css('display', 'none');
    if (window.innerWidth >= 960) $(".btnWrap-search-between.with-sub-categories").hide();
  }
}

/**
 * 検索条件：絞り込み条件のDOMを設定する
 */
const setElementFilterItems = () => {
  $('#filter-items').empty();
  if (selectedSubCategory && selectedSubCategory['filter_items'].length > 0) {
    $("#filter-items").css('display', 'flex');
    if (window.innerWidth >= 960) $(".btnWrap-search-between.with-filter-items").show();
    selectedSubCategory['filter_items'].forEach((filterItem, index) => {
      if (filterItem['type'] === 'checkbox' && filterItem['items'].length > 0) {
        $("#filter-items").append(`
          <dl class="matching-item">
            <dt class="matching_item-ttl">${filterItem['label']}</dt>
            <dd class="matching_item-contents"><div class="checkboxWrap filter-item-${index}"></div></dd>
          </dl>
        `);
        filterItem['items'].forEach((item, i) => {
          let checked = '';
          if (selectedFilterItems.hasOwnProperty(filterItem['key'])) {
            for (const selectedValue in selectedFilterItems) {
              if (Array.isArray(selectedFilterItems[selectedValue]['items'])
                && selectedFilterItems[selectedValue]['items'].includes(item['name'])) {
                checked = 'checked';
                break;
              }
            }
          }
          $(`.filter-item-${index}`).append(`
            <span>
              <input type="checkbox" name="c${index}" id="c${index}-${i}" value="${item['name']}" onChange="changeFilterItem(this)" ${checked}>
              <label for="c${index}-${i}">${item['name']}</label>
            </span>
          `);
        });
      }
    });
  } else {
    $("#filter-items").css('display', 'none');
    if (window.innerWidth >= 960) $(".btnWrap-search-between.with-filter-items").hide();
  }
}

/**
 * 検索条件：コラボ／タイトルのDOMを設定する
 */
const setElementCollaboration = () => {
  search_condition_collaborations.forEach((collaboration) => {
    const selected = selectedCollaboration && selectedCollaboration['name'] === collaboration['name'] ? 'selected' : '';
    $("#collaboration").append(`<option value="${collaboration['name']}" ${selected}>${collaboration['name']}</option>`);
  });
}

/**
 * 検索条件：ブランドのDOMを設定する
 */
const setElementBrands = () => {
  if (search_condition_brands.length > 0) {
    $("#brands").css('display', 'flex');
    search_condition_brands.forEach((brand, index) => {
      let checked = '';
      for (let selectedBrand of selectedBrands) {
        if (selectedBrand['name'].toLowerCase() === brand['name'].toLowerCase()) {
          checked = 'checked';
          break;
        }
      }
      $("#brands").append(`
        <span>
          <input type="checkbox" name="c04" id="c04-${index}" value="${brand['name']}" onChange="changeBrand(this)" ${checked}>
          <label for="c04-${index}">${brand['name']}</label>
        </span>
      `);
    });
  } else {
    $('#brands').css('display', 'none');
  }
}

/**
 * 検索条件：カラーのDOMを設定する
 */
const setElementColors = () => {
  search_condition_colors.forEach((color, index) => {
    let checked = '';
    for (let selectedColor of selectedColors) {
      if (selectedColor['name'] === color['name']) {
        checked = 'checked';
        break;
      }
    }
    $("#colors").append(`
      <span>
        <input type="checkbox" name="c_color" id="c05-${index}" value="${color['name']}" onChange="changeColor(this)" ${checked}>
        <label for="c05-${index}" class="${color['className']}"></label>
      </span>
    `);
  });
}

/**
 * 検索条件：販売中のDOMを設定する
 */
const setElementOnSale = () => {
  $("#on-sale").prop('checked', selectedOnSale);
}

/**
 * ソート順の変更を検知する
 */
const setEventSort = () => {
  const target = document.getElementById('sort-by');
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        selectedSort = $("#sort-by").data('sortValue')
        search();
      }
    })
  });
  observer.observe(target, { childList: true });
}

/**
 * タイトルを設定する
 *
 * @returns {string}
 */
const setPageTitle = () => {
  let pageTitle = '';
  if (selectedKeyword) {
    pageTitle += selectedKeyword;
  } else {
    if (!!selectedSubCategory && selectedSubCategory['name']) {
      pageTitle += (!pageTitle) ? selectedSubCategory['name'] : '/' + selectedSubCategory['name'];
    }
    if (!!selectedCollaboration && selectedCollaboration['name'] && selectedCollaboration['name'] !== 'すべて') {
      pageTitle += (!pageTitle) ? selectedCollaboration['name'] : '/' + selectedCollaboration['name'];
    }
    selectedBrands.forEach((brand) => {
      pageTitle += (!pageTitle) ? brand['name'] : '/' + brand['name'];
    })
    if (!pageTitle) pageTitle = 'すべて'
  }
  $("#search-result-title").text(pageTitle);
  return pageTitle;
}

/**
 * インフィニティスクロールを設定する
 */
const setInfinityScroll = () => {
  new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    offset: 200
  });
}

/**
 * 検索条件：カテゴリ変更イベント
 *
 * @param elem
 */
const changeCategory = (elem) => {
  search_condition_categories.some((category) => {
    if (category['name'] === elem.value) {
      selectedCategory = category;
      selectedSubCategory = category['sub_categories'].length > 0 ? category['sub_categories'][0] : null;
      selectedFilterItems = {};
      setElementSubCategory();
      setElementFilterItems();
      return true;
    }
  });
}

/**
 * 検索条件：サブカテゴリ変更イベント
 *
 * @param elem
 */
const changeSubCategory = (elem) => {
  selectedCategory['sub_categories'].some((subCategory) => {
    if (subCategory['name'] === elem.value) {
      selectedSubCategory = subCategory;
      selectedFilterItems = {};
      setElementFilterItems();
      return true;
    }
  });
}

/**
 * 検索条件：絞り込み条件変更イベント
 *
 * @param elem
 */
const changeFilterItem = (elem) => {
  selectedSubCategory['filter_items'].some((filterItem) => {
    if (filterItem['type'] === 'checkbox' && elem) {
      filterItem['items'].some((item) => {
        if (item['name'] === elem.value) {
          if (elem.checked) {
            if (selectedFilterItems.hasOwnProperty(filterItem['key'])) {
              selectedFilterItems[filterItem['key']]['items'].push(item['name']);
            } else {
              selectedFilterItems[filterItem['key']] = { type: 'checkbox', items: [item['name']] };
            }
          } else {
            selectedFilterItems[filterItem['key']]['items']
              = selectedFilterItems[filterItem['key']]['items'].filter(selectedItem => selectedItem !== elem.value);
            if (selectedFilterItems[filterItem['key']]['items'].length === 0) delete selectedFilterItems[filterItem['key']];
          }
        }
      });
    }
  });
}

/**
 * 検索条件：コラボ／タイトル変更イベント
 *
 * @param elem
 */
const changeCollaboration = (elem) => {
  search_condition_collaborations.some((collaboration) => {
    if (collaboration['name'] === elem.value) {
      selectedCollaboration = collaboration;
      return true;
    }
  });
}

/**
 * 検索条件：ブランド変更イベント
 *
 * @param elem
 */
const changeBrand = (elem) => {
  if (elem.checked) {
    search_condition_brands.some((brand) => {
      if (brand['name'].toLowerCase() === elem.value.toLowerCase()) {
        selectedBrands.push(brand);
        return true;
      }
    });
  } else {
    selectedBrands = selectedBrands.filter(selectedBrand => selectedBrand['name'].toLowerCase() !== elem.value.toLowerCase());
  }
}

/**
 * 検索条件：カラー変更イベント
 *
 * @param elem
 */
const changeColor = (elem) => {
  if (elem.checked) {
    search_condition_colors.some((color) => {
      if (color['name'] === elem.value) {
        selectedColors.push(color);
        return true;
      }
    });
  } else {
    selectedColors = selectedColors.filter(selectedColor => selectedColor['name'] !== elem.value)
  }
}

/**
 * 検索条件：販売中ステータス変更イベント
 *
 * @param elem
 */
const changeOnSale = (elem) => {
  selectedOnSale = !!elem.checked;
}

/**
 * キーワードの変更イベントを検知する
 */
const changeKeyword = () => {
  $('#suggest-search-keyword').on('change', (event) => {
    selectedKeyword = $('#suggest-search-keyword').val();
    $(this).data('oldValue', selectedKeyword);
  });
}

/**
 * 検索時、画面いっぱいにローディングを表示
 */
const showLoading = () => {
  $('body').append(`<div id="now-loading"><div class="loaderWrap"><div class="loader"></div></div></div>`);
}

/**
 * ローディング表示を削除
 */
const removeLoading = () => {
  $('#now-loading').fadeOut(1000).queue(() => $('#now-loading').remove());
}

/**
 * オブジェクトの空判定
 * @param obj
 * @returns {boolean}
 */
const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0
}

/**
 * 検索を実行する
 */
const search = () => {
  const url = convertObjectToUrl();
  const xhr = new XMLHttpRequest();

  $('#wrap').removeClass('is-locked');
  $('.search-matching').hide();
  showLoading();

  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const newContainer = xhr.responseXML.querySelectorAll('#search-result')[0];
      const productsCount = xhr.responseXML.querySelectorAll('#product-count')[0];
      const newArticleBox = xhr.responseXML.querySelectorAll('#article-box')[0];
      const newArticle = xhr.responseXML.querySelectorAll('#article-list')[0];
      $('#search-result').empty().append(newContainer.innerHTML);
      $('#product-count').empty().append(productsCount.innerHTML);
      if (newArticleBox.outerHTML.includes('not-exist')) {
        // レスポンス：関連記事なし
        $('#article-list').empty();
        $('#article-box').addClass('not-exist');
      } else {
        // レスポンス：関連記事あり
        $('#article-list').empty().append(newArticle.innerHTML);
        $('#article-box').removeClass('not-exist');
      }
      setInfinityScroll();
      rerunAirReviews();
      const pageTitle = setPageTitle();
      history.pushState(null, '', url);
      document.title = `${pageTitle}の検索結果 | ${shopName}`;
      removeLoading();
      $('body,html').animate({scrollTop: 0}, 500, 'swing');
    } else if (xhr.readyState === 4 && xhr.status !== 200) {
      alert('データの取得に失敗しました。');
      console.error(`Request Faild. ${xhr.statusText}`);
      removeLoading();
    }
  };

  xhr.open('GET', url);
  xhr.responseType = 'document';
  xhr.send();
}

/**
 * AirReviews（レビューアプリ）の本体スクリプトを再読み込み
 */
const rerunAirReviews = () => {
  let done = false;
  let script = document.createElement('script');
  script.src = airReviewsSrc;
  document.body.appendChild(script);

  script.onload = script.onreadystatechange = function() {
    if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
      done = true;
      // Handle memory leak in IE
      script.onload = script.onreadystatechange = null;
      document.body.removeChild(script);
    }
  };
}

/**
 * 初期処理
 *
 * 1. URLのパラメータをコード上で利用しやすいように、オブジェクトに変換する
 * 2. パラメータオブジェクトから、選択中の各種条件を設定する
 * 3. 各条件の項目を生成して、選択中のものにはselectedを設定する
 * 4. 商品リストを取得する
 */
$(function() {
  // 1. URLのパラメータをコード上で利用しやすいように、オブジェクトに変換する
  convertUrlQueriesToObject();
  // 2. パラメータオブジェクトから、選択中の各種条件を設定する
  setCategoryFromUrlParamObject();
  setSubCategoryFromUrlParamObject();
  setFilterItemsFromUrlParamObject();
  setCollaborationFromUrlParamObject();
  setBrandsFromUrlParamObject();
  setColorsFromUrlParamObject();
  setOnSaleFromUrlParamObject();
  setSort();
  setKeyword();
  changeKeyword();
  // 3. 各条件の項目を生成して、選択中のものにはselectedを設定する
  setElementCategory();
  setElementSubCategory();
  setElementFilterItems();
  setElementCollaboration();
  setElementBrands();
  setElementColors();
  setElementOnSale();
  setEventSort();
  setPageTitle();
  setInfinityScroll();

  // レビューアプリのJSがインフィニティスクロール後にうまく動かないので、再読み込みさせる
  const allScripts = document.getElementsByTagName('script');
  for (const scriptElement of allScripts) {
    if (/air-reviews-main\.min\.js/.test(scriptElement.src)) {
      airReviewsSrc = scriptElement.src;
      break;
    }
  }
});

/**
 * リロード時に画面TOPに戻らない対策
 */
$(window).on('load', function() {
  $('html,body').animate({ scrollTop: 0 }, '1');
});